export const environment = {
  production: false,
  apiBaseUrl: 'https://tb.bff.dev.ztrax.com.br/api',
  appVersion: 'v2.1',
};
